var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0 fill-height",attrs:{"fluid":""}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }